import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["file-input"];

  connect() {
    this.chosenFiles = {};
    this.listeners = {};
  }

  fileInputOutletConnected(outlet, element) {
    const inputName = outlet.inputTarget.name;

    if (this.chosenFiles[inputName]) {
      outlet.setFiles(this.chosenFiles[inputName]);
    }

    function persistFileChoice() {
      this.chosenFiles[inputName] = outlet.getFiles();
    }

    this.listeners[inputName] = persistFileChoice.bind(this);

    outlet.inputTarget.addEventListener("change", this.listeners[inputName]);
  }

  fileInputOutletDisconnected(outlet) {
    const inputName = outlet.inputTarget.name;

    outlet.inputTarget.removeEventListener("change", this.listeners[inputName]);
    delete this.listeners[inputName];
  }
}
